<template>
  <div class="containerContacts">
    <h3 class="sectionTitle contactsTitle" data-aos="fade-up">Контакти</h3>
    <div class="contactsWrapper contentWrapperPadding">
      <div v-for="contact in contacts" :key="contact.key" class="">
        <ContantCard
          :contact="contact"
          data-aos="fade-up"
          data-aos-offset="-50"
        />
      </div>
    </div>
    <div class="footer">
      <p class="text26 footerText">
        © 2023 | POWERED BY
        <a
          href="https://best-lviv.org.ua/"
          rel="noreferrer noopener"
          target="_blank"
          class="footerLink"
          >BEST LVIV</a
        >
      </p>
    </div>
  </div>
</template>

<script>
import ContantCard from './components/ContantCard.vue';

export default {
  name: 'Contants',
  components: {
    ContantCard
  },
  data: () => ({
    contacts: [
      {
        name: 'Стріла Ілля',
        position: 'Головний організатор',
        tel: '+380689619070',
        mail: 'illia.strila@gmail.com',
        linkedIn: 'https://www.linkedin.com/in/ilia-strila-abaa57179/',
        img: 'illya',
        inst: 'https://instagram.com/arquballista',
        telegram: 'https://t.me/arquballista'
      },
      {
        name: 'Гошина Діана',
        position: 'Відповідальна за корпоративні зв’язки',
        tel: '+380689706121',
        mail: 'dianagoshina00@gmail.com',
        linkedIn:
          'https://www.linkedin.com/in/%D0%B4%D1%96%D0%B0%D0%BD%D0%B0-%D0%B3%D0%BE%D1%88%D0%B8%D0%BD%D0%B0-258004268/',
        img: 'diana',
        inst: 'https://www.instagram.com/_diana_goshyna_',
        telegram: 'https://t.me/GoshinaDiana'
      }
    ]
  })
};
</script>

<style lang="scss" scoped>
.containerContacts {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.contactsWrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 10rem;
  margin-top: 14rem;
  gap: 10rem;
}

.footer {
  display: flex;
  justify-content: center;
}

.footerText {
  padding-bottom: 5rem;
  font-weight: 900;
}

.footerLink {
  color: #4f388d;
}

@media screen and (max-width: 768px) {
  .contactsWrapper {
    flex-direction: column;
    padding-bottom: 25rem;
    gap: 42.5rem;
    margin-top: 0;
  }
  .footerText {
    padding-bottom: 10rem;
  }
  .footerLink {
    color: #4f388d;
  }

  .contactsTitle {
    margin-bottom: 50rem;
  }
}
</style>
